<template>
  <form
    accept-charset="utf-8"
    action="/"
    enctype="application/x-www-form-urlencoded"
    id="login"
    method="post"
    role="form"
  >
    <div class="bg-white border-secondary shadow-sm rounded p-3 h-100 mt-2 mb-2">
      <div class="text-step">
        <h5>
          <span class="badge badge-pill badge-warning mr-3">STEP 1</span>
          <span class="title pt-2 mt-2">ระบุเบอร์โทร</span>
        </h5>
        <b-row>
          <b-col>
            <h6 class="subtitle mt-1">
              <i class="fas fa-mobile-alt mr-2"></i> ลืมรหัสผ่าน เพียงแค่ใส่ชื่อผู้ใช้และเบอร์ที่เคยใช้สมัคร
            </h6>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="4" sm="4" md="2" class="text-right pt-2">
            ชื่อผู้ใช้
          </b-col>
          <b-col cols="8" sm="8" md="4">
            <input
              type="name"
              name="username"
              class="form-control"
              required
              placeholder="Username"
              v-model="userInfo.username"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="4" sm="4" md="2" class="text-right pt-2">
            <span class="flag-icon flag-icon-th mr-1">
              <img src="../../assets/flags/4x3/th.svg" /> +66
            </span>
          </b-col>
          <b-col cols="8" sm="8" md="4">
            <input
              type="tel"
              name="tel"
              pattern="\d*"
              class="form-control telinput"
              minlength="10"
              maxlength="10"
              required
              oninput="inputtel(this);"
              placeholder="ใส่เบอร์โทรศัพท์"
              v-model="userInfo.mobile"
            />
          </b-col>
          <b-col
            cols="12"
            sm="12"
            md="6"
            class="text-right text-sm-right text-md-left pt-0 pt-md-2"
          >
            <small class="text-secondary">กรุณาใส่หมายเลขโทรศัพท์เพื่อยืนยันตัวตน</small>
          </b-col>
          <b-col cols="12" class="border-bottom my-3"></b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="12" class="mb-2">
            <i class="fas fa-shield-alt mr-2"></i> กรุณายืนยันว่าท่านไม่ใช่โรบอท
          </b-col>
          <b-col cols="12">
            <vue-recaptcha :sitekey="getReCaptchaKey"></vue-recaptcha>
          </b-col>
        </b-row>
      </div>
    </div>
    <b-card class="bg-secondary border-dark shadow-sm mt-0 p-0 mb-0" body-class="py-1">
      <div class="row">
        <div class="col p-2">
          <router-link class="btn btn-dark btn-block" to="/">
            <i class="fas fa-chevron-left"></i> ย้อนกลับ
          </router-link>
        </div>
        <div class="col p-2">
          <button type="submit" class="btn golden-btn btn-block" @click="register($event)" :disabled="userInfo.mobile.length == 10 ? false : 'disabled'">
            &nbsp;&nbsp;&nbsp;ถัดไป
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </b-card>
  </form>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import VueRecaptcha from "vue-recaptcha";
import { mapGetters } from "vuex";

export default {
  name: "ForgotPasswordStep1",
  components: { VueRecaptcha },
  data() {
    return {
      btnDisabled: 'disabled',
      userInfo: {
        mobile: "",
        username: ""
      }
    };
  },
  methods: {
    register(e) {
      e.preventDefault();
      this.$emit('setPhone', this.userInfo)
    }
  },
  computed: {
    ...mapGetters({
      getReCaptchaKey: "getReCaptchaKey"
    })
  }
};
</script>

<style lang="scss" scoped>
.text-shadow {
  text-shadow: rgb(0 0 0 / 50%) 1px 1px 3px;
}

.head-tab {
  h3 {
    font-family: SukhumvitBold;
  }
}

.logoindex {
  /* background: url(../images/logo-fifalotto-white.png) no-repeat top center; */
  background-size: cover;
  height: 40px;
  margin: 0 auto;
  position: relative;
  display: inline-block;
  vertical-align: middle;

  a {
    color: black;
  }
}

.flag-icon {
  img {
    height: 1em;
    line-height: 1em;
  }
}

.item {
  h3 {
    font-size: 150%;
  }

  h4 {
    font-size: 130%;
    color: #bd841b;
  }

  table {
    thead {
      tr {
        th {
          vertical-align: bottom;
          border-bottom: 2px solid #dee2e6;
        }
      }
    }

    tbody {
      tr {
        td.first-val {
          color: rgb(189, 132, 41) !important;
        }
      }
    }

    .text-border-number {
      text-shadow: #fff 2px 0px 0px, #fff 1.75517px 0.958851px 0px,
        #fff 1.0806px 1.68294px 0px, #fff 0.141474px 1.99499px 0px,
        #fff -0.832294px 1.81859px 0px, #fff -1.60229px 1.19694px 0px,
        #fff -1.97998px 0.28224px 0px, #fff -1.87291px -0.701566px 0px,
        #fff -1.30729px -1.5136px 0px, #fff -0.421592px -1.95506px 0px,
        #fff 0.567324px -1.91785px 0px, #fff 1.41734px -1.41108px 0px,
        #fff 1.92034px -0.558831px 0px;
      letter-spacing: 0.04em;
    }
  }
}

.text-step {
  font-family: SukhumvitBold;

  .title {
    color: rgb(189, 132, 41) !important;
  }
}

.indexlogo {
  width: 100%;
}

.goldpattern {
  background-size: 100%;
  background: url(../../assets/images/gold-pattern.jpg) top center;
}

.select-btn {
  color: #b47e18 !important;
  background-color: white !important;
  background-image: none;
  border-color: #bd841b !important;
  word-wrap: break-word;
  overflow: hidden;
  display: block;
  font-family: Sukhumvit;
}

.select-btn:hover {
  color: white !important;
  background-color: #bd841b !important;
  background-image: none;
  border-color: #bd841b !important;
}
</style>